export const REFERENCE_TYPES = [
  { key: 'numberedItem', label: 'Numbered list item' },
  { key: 'heading', label: 'Heading' },
  { key: 'bookmark', label: 'Bookmark' },
] as const;

export type ReferenceType = (typeof REFERENCE_TYPES)[number]['key'];

export function isReferenceType(value: string): value is ReferenceType {
  return REFERENCE_TYPES.some(referenceType => referenceType.key === value);
}

export const EMPTY_TARGET_LABELS: Record<ReferenceType, string> = {
  bookmark: 'No bookmarks found',
  heading: 'No headings found',
  numberedItem: 'No numbered list items found',
};

export interface InsertReferenceToOption {
  instruction: 'REF' | 'PAGEREF';
  key: string;
  label: string;
  switches: string;
}

export const INSERT_REFERENCE_TO_OPTIONS: Record<ReferenceType, InsertReferenceToOption[]> = {
  bookmark: [
    {
      instruction: 'REF',
      key: 'bookmark-text',
      label: 'Bookmark text',
      switches: '\\h',
    },
    {
      instruction: 'PAGEREF',
      key: 'bookmark-page-number',
      label: 'Page number',
      switches: '\\h',
    },
    {
      instruction: 'REF',
      key: 'bookmark-paragraph-number',
      label: 'Paragraph number within a list',
      switches: '\\r \\h',
    },
    {
      instruction: 'REF',
      key: 'bookmark-paragraph-number-no-context',
      label: 'Paragraph number within a list (current level only)',
      switches: '\\n \\h',
    },
    {
      instruction: 'REF',
      key: 'bookmark-paragraph-number-full-context',
      label: 'Paragraph number within a list (full hierarchy)',
      switches: '\\w \\h',
    },
    {
      instruction: 'REF',
      key: 'bookmark-above-below',
      label: 'Above/below',
      switches: '\\p \\h',
    },
  ],
  heading: [
    {
      instruction: 'REF',
      key: 'heading-text',
      label: 'Heading text',
      switches: '\\h',
    },
    {
      instruction: 'PAGEREF',
      key: 'page-number',
      label: 'Page number',
      switches: '\\h',
    },
    {
      instruction: 'REF',
      key: 'heading-number',
      label: 'Heading number within a list',
      switches: '\\r \\h',
    },
    {
      instruction: 'REF',
      key: 'heading-number-no-context',
      label: 'Heading number within a list (current level only)',
      switches: '\\n \\h',
    },
    {
      instruction: 'REF',
      key: 'heading-number-full-context',
      label: 'Heading number within a list (full hierarchy)',
      switches: '\\w \\h',
    },
    {
      instruction: 'REF',
      key: 'above-below',
      label: 'Above/below',
      switches: '\\p \\h',
    },
  ],
  numberedItem: [
    {
      instruction: 'PAGEREF',
      key: 'numbered-page-number',
      label: 'Page number',
      switches: '\\h',
    },
    {
      instruction: 'REF',
      key: 'numbered-paragraph-number',
      label: 'Paragraph number',
      switches: '\\r \\h',
    },
    {
      instruction: 'REF',
      key: 'paragraph-number-no-context',
      label: 'Paragraph number (current level only)',
      switches: '\\n \\h',
    },
    {
      instruction: 'REF',
      key: 'paragraph-number-full-context',
      label: 'Paragraph number (full hierarchy)',
      switches: '\\w \\h',
    },
    {
      instruction: 'REF',
      key: 'numbered-above-below',
      label: 'Above/below',
      switches: '\\p \\h',
    },
  ],
};
